import { cn, putComma } from "@/lib/utils";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../ui/button";
import { setOpenConvertPositionSlice } from "@/store/features/positionsSlice";
import { Mixpanel } from "@/elements/Mixpanel";
import { getInstrument } from "@/lib/tradeCards";
import { useMemo } from "react";
import { SlArrowDown } from "react-icons/sl";
import { updateField } from "@/store/features/stocksDetailsSlice";

function StockOHLCDetails({ data: datas }) {
    const data = useMemo(() => datas, [datas]);
    const dispatch = useDispatch();
    const { positionsDetails, finCode, isPerformance } = useSelector((state) => state.stocksDetails);

    const handleConvertPosition = () => {
        dispatch(
            setOpenConvertPositionSlice({
                isOpen: true,
                finCode,
                positionsDetails
            })
        );
        Mixpanel.track("cta_clicked", {
            cta_text: "convert_position",
            page: "positions_bf",
            tab: "positions",
            symbol: positionsDetails?.symbol,
            instrument_name: getInstrument(positionsDetails?.symbol),
            is_position_open: positionsDetails?.open ? "yes" : "no",
            is_gtt: positionsDetails?.hasGtt ? "yes" : "no",
            is_tradeidea: positionsDetails?.tradeCardId ? "yes" : "no",
            expiry_date: null,
            product: positionsDetails?.productTag
        });
    };

    return (
        <div className="px-4 font-Inter">
            <hr className="" />
            <div
                className="flex justify-between cursor-pointer mt-4"
                onClick={() => dispatch(updateField({ field: "isPerformance", value: !isPerformance }))}
            >
                <div className="text-sm font-semibold text-black">Performance</div>
                <div className="text-sm font-semibold text-black">
                    <SlArrowDown
                        size={16}
                        className={cn(isPerformance ? "rotate-180" : "rotate-0", "transition-all")}
                    />
                </div>
            </div>
            <div className={`transition-all overflow-hidden  ${isPerformance ? "max-h-[600px] pt-4" : "pt-0 max-h-0"}`}>
                <div className="grid grid-cols-4 py-4">
                    <div className="flex flex-col justify-center text-[#747474] font-medium text-xs text-center">
                        Open
                        <div className="text-black text-xs leading-5 font-semibold">₹{putComma(data?.ohlc?.fopen)}</div>
                    </div>
                    <div className="flex flex-col justify-center text-[#747474] font-medium text-xs text-center">
                        Low
                        <div className="text-black text-xs leading-5 font-semibold">₹{putComma(data?.ohlc?.flow)}</div>
                    </div>
                    <div className="flex flex-col justify-center text-[#747474] font-medium text-xs text-center">
                        High
                        <div className="text-black text-xs leading-5 font-semibold">₹{putComma(data?.ohlc?.fhigh)}</div>
                    </div>
                    <div className="flex flex-col justify-center text-[#747474] font-medium text-xs text-center">
                        Prev. close
                        <div className="text-black text-xs leading-5 font-semibold">
                            ₹{putComma(data?.ohlc?.fclose)}
                        </div>
                    </div>
                </div>
                <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                    <p className="font-medium text-[#414141]">Lower circuit</p>
                    <p className="font-bold">₹{putComma(data?.ckt?.lckt)}</p>
                </div>
                <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                    <p className="font-medium text-[#414141]">Upper circuit</p>
                    <p className="font-bold">₹{putComma(data?.ckt?.uckt)}</p>
                </div>
                <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                    <p className="font-medium text-[#414141]">Volume</p>
                    <p className="font-bold">{putComma(data?.trade?.volume, 0)}</p>
                </div>
                <div className="flex justify-between items-center p-2 rounded-md text-black text-xs leading-5">
                    <p className="font-medium text-[#414141]">Last traded qty.</p>
                    <p className="font-bold">{putComma(data?.trade?.ltq, 0)}</p>
                </div>
                <div className="flex justify-between items-center bg-[#F5F5F5] p-2 rounded-md text-black text-xs leading-5">
                    <p className="font-medium text-[#414141]">Last traded at</p>
                    <p className="font-bold">{moment(data?.trade?.ltt).format("DD-MM-YYYY | hh:mm:ss")}</p>
                </div>
            </div>
            {positionsDetails?.productType && positionsDetails?.open && (
                <>
                    <hr className="my-4" />
                    <div className="w-full  items-center flex flex-col">
                        <Button
                            onClick={() => handleConvertPosition()}
                            variant={"BUY"}
                            className=" text-base font-bold h-12 rounded-lg "
                        >
                            Convert position
                        </Button>
                    </div>
                </>
            )}
        </div>
    );
}

export default StockOHLCDetails;
